import { sendDataProcessing, setDataUsers, fetchUsers } from "../../helpers/fetching";
import mutations from "../mutations";

export default {
  state: {
    processing: {},
    loading: false,
    error: null,
    userList: [],
  },
  mutations,
  actions: {
    setTempProcessing({ commit }, data){
      commit("setState", { key: "processing", value: data });
    },
    /* eslint-disable */
    setProcessing({ commit }, data) {
      return new Promise(async (resolve) => {
        commit("setState", { key: "loading", value: true });
        await new Promise(r=>{
          sendDataProcessing({
            session_uuid: window.person.id,
            origin_url: window.location.href,
            action: 'Click: ' + data.action,
            document: data.document,
            appointment_code: data.appointment_code,
            origin: process.env.PACKAGE_NAME,
          }, r);
        });
        commit("setState", { key: "loading", value: false });
        resolve();
      });
    },
    postUsers({ commit }, data){
      return new Promise(async (resolve) => {
        commit("setState", { key: "loading", value: true });
        await new Promise(resolve => {
          setDataUsers({
            id: data.id || null,
            session_uuid: window.person.id,
            name: data.name,
            document: data.document,
            documentType: data.documentType,
            phone: data.phone,
            address: data.address,
            email: data.email
          }, resolve);
        });
        commit("setState", { key: "loading", value: false });
        resolve();
      });
    },
    getUsers({ commit }, data){
      return new Promise(async (resolve) => {
        commit("setState", { key: "loading", value: true });
        // from mysql
        let response = await new Promise(resolve => {
          fetchUsers(data, resolve);
        }) 
        commit("setState", { key: "userList", value: response ? response.data : [] });
        commit("setState", { key: "loading", value: false });
        resolve();
      });
    },
    getProcessing({ commit }, data) {
      return new Promise(async (resolve) => {
        commit("setState", { key: "loading", value: true });
        let response = await new Promise(r=>{
          sendDataProcessing({
            session_uuid: window.person.id,
            origin_url: window.location.href,
            action: 'Click: ' + data.action,
            document: data.document,
            origin: process.env.PACKAGE_NAME,
          }, r);
        }) 
        commit("setState", { key: "processing", value: response });
        commit("setState", { key: "loading", value: false });
        resolve();
      });
    },
    resetEnvironment({ commit }) {
      commit("setState", { key: "processing", value: {} });
    },
    /* eslint-enable */
  },
};
